import { useState, useMemo, useCallback } from 'react';
import {
  DAppSdkClientContext,
  DAppSdkClientState,
  defaultDAppSdkClientState,
} from './DAppSdkContext';

export const DAppSdkClientProvider = ({ children }: React.PropsWithChildren) => {
  const [client, setClientInProvider] = useState<DAppSdkClientState['client']>(
    defaultDAppSdkClientState.client,
  );

  const resetDAppSdkClient = useCallback(() => {
    setClientInProvider(defaultDAppSdkClientState.client);
  }, []);

  const clientState = useMemo(() => {
    return {
      client,
      setClient: setClientInProvider,
      resetClient: resetDAppSdkClient,
    };
  }, [client, resetDAppSdkClient]);

  return (
    <DAppSdkClientContext.Provider value={clientState}>{children}</DAppSdkClientContext.Provider>
  );
};
